import {
  IconButton,
  Dialog,
  DialogTitle,
  AppBar,
  Toolbar,
  Typography,
  Box,
  CircularProgress,
  DialogContent,
  DialogActions,
  Tooltip,
  Button,
  TextField,
  Autocomplete,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider,
  Menu,
  MenuItem,
  FormGroup,
  Checkbox,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { currencyFormat } from "../../common/components/Utils";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PreviewIcon from "@mui/icons-material/Preview";
import InfoIcon from "@mui/icons-material/Info";
import { Help } from "@mui/icons-material";
import {
  addOrUpdateTeacher,
  getSchoolPositions,
  getDistricts,
} from "../../../../store/posts/actions";
import { getSectors } from "../../../../store/posts/actions";
import {
  getTeacherProfile,
  updateUserProfile,
  getProfileDocumentTypes,
  getProfileDocuments,
} from "../../../../store/users/actions";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";

import { isEmpty } from "lodash";
import axios from "axios";
import { CSVLink } from "react-csv";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import moment from "moment";
import { showError } from "../../../toastify";
import defaultPofile from "../../../assets/default-profile.jpg";
// import { idNumberPattern } from "../../common/components/Utils";
import LockIcon from "@mui/icons-material/Lock";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import MaskedInput from "react-text-mask";
import joi from "joi";

import { Link } from "react-router-dom";

const personalEmailValidator = joi.object({
  email: joi.string().email({
    minDomainSegments: 2,
    tlds: { allow: ["com", "fr", "rw"] },
  }),
});

const getDocumentDescription = (documentId) => {
  const descriptions = {
    1: "This is a document that certifies your academic achievement. Upload your official degree certificate or diploma issued by a recognized educational institution to verify your qualification level.",
    2: "This is a document that shows your academic performance. Upload your official academic transcript that displays all courses taken, grades received, and overall academic standing during your studies.",
    3: "This is a document that confirms your employment. Upload your official appointment letter from the Ministry of Education or school administration that confirms your teaching position and employment details.",
    4: "This is a document that demonstrates your professional development. Upload your Continuous Professional Development certificate if you have completed any CPD programs, workshops, or training sessions to enhance your teaching skills.",
    5: "This is a document that certifies any special needs or accommodations. Upload documentation of any disability status if applicable, issued by relevant medical authorities or government agencies for support services.",
    6: "This is a document that evaluates your work performance. Upload your most recent performance evaluation or appraisal document from your school or education authority that assesses your teaching effectiveness and professional conduct.",
  };
  return (
    descriptions[documentId] ||
    "This is a required document. Please upload the specified document to complete your profile."
  );
};

const TeacherProfile = (props) => {
  useEffect(() => {
    document.title = "TMIS | Teacher profile";
  }, []);

  const {
    user,
    loading,
    teacherProfile,
    getTeacherProfile,
    getDistricts,
    districts,
    updateUserProfile,
    scholarshipDocuments,
    getProfileDocumentTypes,
    getProfileDocuments,

    profileDocumentTypes,
    profileDocuments,
  } = props;

  const [sectors, setSectors] = useState([]);
  const [cells, setCells] = useState([]);
  const [villages, setVillages] = useState([]);

  const [district, setDistrict] = useState(null);
  const [sector, setSector] = useState(null);
  const [cell, setCell] = useState(null);
  const [village, setVillage] = useState(null);

  useEffect(() => {
    getProfileDocumentTypes();

    getProfileDocuments(user.id);

    getTeacherProfile(user.id);
    if (!districts.length) getDistricts();

    if (!!teacherProfile?.residenceDistrictId)
      getSectors(teacherProfile?.residenceDistrictId);

    if (!!teacherProfile?.residenceSectorId)
      getCells(teacherProfile?.residenceSectorId);

    if (!!teacherProfile?.residenceCellId)
      getVillages(teacherProfile?.residenceCellId);
  }, []);

  useEffect(() => {
    if (!!district?.id) getSectors(district.id);
  }, [district]);

  useEffect(() => {
    if (!!sector?.id) getCells(sector.id);
  }, [sector]);

  useEffect(() => {
    if (!!cell?.id) getVillages(cell.id);
  }, [cell]);

  const getSectors = async (districtId) => {
    try {
      const { data } = await axios.get(`/api/posts/sectors/` + districtId);
      setSectors(data);
    } catch (error) {}
  };

  const getCells = async (sectorId) => {
    try {
      const { data } = await axios.get(`/api/posts/cells/` + sectorId);
      setCells(data);
    } catch (error) {}
  };

  const getVillages = async (cellId) => {
    try {
      const { data } = await axios.get(`/api/posts/villages/` + cellId);
      setVillages(data);
    } catch (error) {}
  };

  useEffect(() => {
    if (!!teacherProfile?.residenceDistrictId && districts.length)
      setDistrict(
        districts.find((d) => d.id === teacherProfile?.residenceDistrictId) ||
          null,
      );
  }, [teacherProfile, districts]);

  useEffect(() => {
    if (!!teacherProfile?.residenceSectorId && sectors.length)
      setSector(
        sectors.find((d) => d.id === teacherProfile?.residenceSectorId) || null,
      );
  }, [teacherProfile, sectors]);

  useEffect(() => {
    if (!!teacherProfile?.residenceCellId && cells.length)
      setCell(
        cells.find((d) => d.id === teacherProfile?.residenceCellId) || null,
      );
  }, [teacherProfile, cells]);

  useEffect(() => {
    if (!!teacherProfile?.residenceVillageId && villages.length)
      setVillage(
        villages.find(
          (v) => v.ippisVillageCode === teacherProfile?.residenceVillageId,
        ) || null,
      );
  }, [teacherProfile, villages]);

  const [profileAttachments, setProfileAttachments] = useState([]);
  const [showUploadedDocument, setShowUploadedDocument] = useState(false);
  const [uploadedDocument, setUploadedDocument] = useState(null);
  const [hasDisability, setHasDisability] = useState(false);

  const convertToLower = (value) => {
    return value.toLowerCase();
  };

  const isFileTooLarge = (file) => {
    const size = file.size;
    return size > 3222528 ? true : false;
  };

  const handleUploadedPDFFile = (event, document) => {
    let pdfAttachment = event.target.files[0];

    if (convertToLower(pdfAttachment?.name?.substr(-4)) !== ".pdf") {
      showError("File should be pdf format");
    } else if (isFileTooLarge(pdfAttachment)) {
      showError("Allowed file should not exceed 3MB");
    } else {
      const index = profileAttachments.findIndex(
        ({ id }) => id === document.id,
      );
      const attachments = [...profileAttachments];
      document.file = pdfAttachment;
      document.filename = pdfAttachment.name;

      const reader = new FileReader();

      reader.onload = (e) => {
        document.url = e.target.result;
      };

      reader.readAsDataURL(pdfAttachment);

      if (index < 0) attachments.push(document);
      else attachments[index] = document;

      setProfileAttachments(attachments);
    }
  };

  useEffect(() => {
    const tmp = [];

    profileDocuments.forEach((doc) => {
      tmp.push({
        id: doc.profileDocumentTypeId,
        filename: profileDocumentTypes.find(
          ({ id }) => id === doc.profileDocumentTypeId,
        )?.name,
        url: doc.filePath,
      });
    });

    setProfileAttachments(tmp);

    // Check if disability document exists to set hasDisability state
    const disabilityDoc = profileDocuments.find(
      (doc) => doc.profileDocumentTypeId === 5,
    );
    if (disabilityDoc) {
      setHasDisability(true);
    }
  }, [profileDocuments, profileDocumentTypes]);

  const onSave = () => {
    const payload = new FormData();

    profileAttachments.forEach((row, i) => {
      if (!!row.file) {
        payload.append("files", row.file);
        payload.append(`docIds`, row.id);
      }
    });

    payload.append("userId", user.id);
    payload.append("residenceVillageId", village?.ippisVillageCode || null);
    // Add disability status to payload
    payload.append("hasDisability", hasDisability);

    updateUserProfile(payload);
  };

  // Assigned Subjects State for Read-Only View
  const [teacherSubjects, setTeacherSubjects] = useState([]);

  const [teacherCertificates, setTeacherCertificates] = useState([]);
  const [cpdCompletionCertificates, setCpdCompletionCertificates] = useState([]);

  const getAssignedSubjects = async () => {
    if (!teacherProfile || !teacherProfile.teacherPlacementId) return;
    try {
      const { data } = await axios.get(
        `/api/posts/teacher-subjects/${teacherProfile.teacherPlacementId}`,
      );
      setTeacherSubjects(data);
    } catch (error) {}
  };

  const getTeacherCertificates = async () => {
    try {
      const { data } = await axios.get(`/api/cpd/teacher-certificates`);
      setTeacherCertificates(data);
    } catch (error) {}
  };

  const getCpdCompletionCertificates = async () => {
    try {
      const { data } = await axios.get(`/api/cpd/training-certificates`);
      setCpdCompletionCertificates(Array.isArray(data) ? data : []);
    } catch (error) {
      setCpdCompletionCertificates([]);
    }
  };

  useEffect(() => {
    if (teacherProfile) {
      getAssignedSubjects();
      getTeacherCertificates();
      getCpdCompletionCertificates();
    }
  }, [teacherProfile]);

  return (
    <>
      <div>
        <div className="row mx-0 mt-3">
          <div className="col-sm-12">
            <React.Fragment>
              <div>
                <div className="row no-gutters">
                  <div className="col-2 justify-content-center  text-center">
                    <div
                      style={{
                        minHeight: "150px",
                        overflow: "hidden",
                      }}
                    >
                      <>
                        <img
                          className="mt-0 rounded  text-center"
                          src={
                            !!teacherProfile.profilePicture
                              ? "data:image/jpg;base64," +
                                teacherProfile.profilePicture
                              : defaultPofile
                          }
                          style={{
                            border: "1px solid #a7a7a7",
                            height: "150px",
                            width: "120px",
                            overflow: "hidden",
                            borderRadius: "50%",
                          }}
                        />
                      </>
                    </div>
                    <div className="text-primary">
                      <strong>NID PHOTO</strong>{" "}
                    </div>
                    {!!teacherProfile?.id && (
                      <div className="text-primary">
                        <strong>{teacherProfile?.id}</strong>{" "}
                      </div>
                    )}
                    <label className="text-center text-uppercase  mt-n2">
                      <span style={{ fontSize: "12px" }}>
                        {teacherProfile?.lastName} {teacherProfile?.firstName}
                      </span>
                    </label>{" "}
                    {!isEmpty(teacherProfile) && (
                      <FormControl
                        className="mt-3 d-block border rounded pt-2"
                        style={{ backgroundColor: "#eee" }}
                      >
                        <FormLabel className="text-primary  px-2">
                          Education certficate
                        </FormLabel>
                        <RadioGroup
                          className="mt-0 d-flex justify-content-start px-4"
                          row
                          name="hasEducationCertficate"
                          value={
                            teacherProfile?.hasEducationCertficate || false
                          }
                        >
                          {!!JSON.parse(
                            teacherProfile.hasEducationCertficate,
                          ) && (
                            <FormControlLabel
                              value={true}
                              control={<Radio disableRipple size="small" />}
                              label="Certfied"
                            />
                          )}
                          {!JSON.parse(
                            teacherProfile.hasEducationCertficate,
                          ) && (
                            <FormControlLabel
                              value={false}
                              control={<Radio disableRipple size="small" />}
                              label="Not certfied"
                            />
                          )}
                        </RadioGroup>
                      </FormControl>
                    )}
                    <span className="text-uppercase mt-1 mb-2 d-block">
                      <Link to="/in/security/change-password">
                        Change password
                      </Link>
                    </span>
                  </div>

                  <div
                    className="col-10 row mx-0 "
                    style={{
                      height: "70vh",
                      backgroundColor: "#f3f4f6",
                      overflowY: "auto",
                      // borderRadius: "0.5rem",
                      // boxShadow: "0 5px 5px 0 rgb(42 119 144 / 5%)",
                      // MozBoxShadow: "0 5px 5px 0 rgba(42,119,144,.05)",
                    }}
                  >
                    <div className="col-4 justify-content-center mt-2">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        InputProps={{
                          readOnly: true,
                          endAdornment: (
                            <>
                              {!teacherProfile.isNIDVerified && !loading && (
                                <span className="loaderIcon text-danger d-flex align-items-center">
                                  <span className="material-icons text-danger">
                                    report_problem
                                  </span>
                                  <span style={{ fontSize: "10px" }}>
                                    Error
                                  </span>
                                </span>
                              )}

                              {!!teacherProfile.isNIDVerified && !loading && (
                                <span className="loaderIcon text-success d-flex align-items-center">
                                  <span className="material-icons text-success ">
                                    verified
                                  </span>
                                  <span style={{ fontSize: "10px" }}>
                                    Verified
                                  </span>
                                </span>
                              )}
                            </>
                          ),
                        }}
                        fullWidth
                        size="small"
                        autoComplete="false"
                        name="nidNumber"
                        label="NID Number"
                        placeholder="NID Number"
                        variant="outlined"
                        value={teacherProfile.nidNumber || ""}
                      />
                    </div>

                    <div className="col-4 text-left mt-2">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        InputProps={{
                          readOnly: true,
                        }}
                        fullWidth
                        size="small"
                        autoComplete="false"
                        name="passportNumber"
                        label="Passport number"
                        placeholder="Passport number"
                        variant="outlined"
                        value={teacherProfile.passportNumber || ""}
                      />
                    </div>

                    <div className="col-2 text-left mt-2">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="civilStatus"
                        label="Civil Status"
                        variant="outlined"
                        value={teacherProfile.civilStatus || ""}
                      />
                    </div>
                    <div className="col-2 text-left mt-2">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="gender"
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Gender"
                        variant="outlined"
                        className=" font-weight-bold"
                        value={teacherProfile.gender || ""}
                      />
                    </div>
                    <div className="col-4  mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="lastName"
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Last Name"
                        variant="outlined"
                        className=""
                        value={teacherProfile.lastName || ""}
                      />
                    </div>
                    <div className="col-4  mt-3  text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="firstName"
                        InputProps={{
                          readOnly: true,
                        }}
                        label="First Name"
                        variant="outlined"
                        className=""
                        value={teacherProfile.firstName || ""}
                      />
                    </div>

                    <div className="col-4  mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="dateOfBirth"
                        value={
                          !!teacherProfile.dateOfBirth
                            ? moment(teacherProfile.dateOfBirth).format(
                                "DD/MM/yyyy",
                              )
                            : ""
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Date Of Birth"
                        variant="outlined"
                      />
                    </div>
                    <div className="col-4  mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="countryOfBirth"
                        value={teacherProfile.countryOfBirth || ""}
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Country of Birth"
                        variant="outlined"
                        className=""
                      />
                    </div>
                    <div className="col-4  mt-3 text-left">
                      <TextField
                        InputProps={{
                          readOnly: true,
                        }}
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="placeOfBirth"
                        value={teacherProfile.placeOfBirth || ""}
                        label="Place of Birth"
                        variant="outlined"
                        className=""
                      />
                    </div>

                    <div className="col-4  mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="nationality"
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Nationality"
                        placeholder="Nationality"
                        variant="outlined"
                        className=" font-weight-bold"
                        value={teacherProfile.nationalityId || ""}
                      />
                    </div>

                    <div className="col-4 mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="spouseNames"
                        value={teacherProfile?.spouseNames || "N/A"}
                        label="Your spouse names"
                        placeholder="Your spouse names"
                        variant="outlined"
                        InputProps={{
                          readOnly: true,
                        }}
                      />
                    </div>
                    <div className="col-2 mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="employeeId"
                        value={teacherProfile?.id || ""}
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Employee ID"
                        placeholder="Employee ID"
                        variant="outlined"
                      />
                    </div>
                    <div className="col-2 mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="rssbNumber"
                        value={teacherProfile?.rssbNumber || ""}
                        InputProps={{
                          readOnly: true,
                        }}
                        label="RSSB Number"
                        placeholder="RSSB Number"
                        variant="outlined"
                        className=""
                      />
                    </div>
                    <div className="col-4 mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="bankAccount"
                        value={
                          !teacherProfile.accountNumber
                            ? ""
                            : teacherProfile.accountNumber +
                              " (" +
                              teacherProfile.bankName +
                              ")"
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Bank Account"
                        placeholder="Bank Account"
                        variant="outlined"
                      />
                    </div>
                    <div className="col-6 mt-3 ">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="rssbNumber"
                        value={teacherProfile?.positionName || ""}
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Position"
                        placeholder="Position"
                        variant="outlined"
                        className=""
                      />
                    </div>
                    <div className="col-6 mt-3 ">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="schoolName"
                        value={
                          !!teacherProfile?.schoolName
                            ? teacherProfile?.schoolName +
                              "/" +
                              teacherProfile?.sectorName +
                              "/" +
                              teacherProfile?.districtName
                            : ""
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        label="School"
                        placeholder="School"
                        variant="outlined"
                        className=""
                      />
                    </div>

                    <div className="col-3 mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="teachingLevel"
                        value={teacherProfile?.teachingLevelName || ""}
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Teaching Level"
                        placeholder="Teaching Level"
                        variant="outlined"
                      />
                    </div>

                    <div className="col-3 mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="qualificationLevel"
                        value={teacherProfile?.qualificationLevelName || ""}
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Position qualification"
                        placeholder="Position qualification"
                        variant="outlined"
                      />
                    </div>

                    <div className="col-6 mt-3 ">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="appointmentDate"
                        value={
                          !!teacherProfile.appointmentDate
                            ? moment(teacherProfile.appointmentDate).format(
                                "DD/MM/yyyy",
                              )
                            : ""
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Position appointment date"
                        variant="outlined"
                      />
                    </div>

                    <div className="col-4  mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        InputProps={{
                          readOnly: true,
                        }}
                        fullWidth
                        size="small"
                        autoComplete="false"
                        name="phone"
                        label="Phone number"
                        placeholder="Phone number"
                        variant="outlined"
                        value={teacherProfile.phoneNumber || ""}
                      />
                    </div>

                    <div className="col-4  mt-3 text-left">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        InputProps={{
                          readOnly: true,
                        }}
                        fullWidth
                        size="small"
                        autoComplete="false"
                        name="email"
                        label="Personal email"
                        placeholder="Personal email"
                        variant="outlined"
                        value={teacherProfile.email || ""}
                      />
                    </div>

                    <div className="mt-3 col-4">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        InputProps={{
                          readOnly: true,
                        }}
                        fullWidth
                        size="small"
                        autoComplete="false"
                        name="employmentTypeName"
                        label="Employment Type"
                        placeholder="Employment Type"
                        variant="outlined"
                        value={teacherProfile.employmentTypeName || ""}
                      />
                    </div>

                    <div className="mt-3 col-4 mb-3">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        InputProps={{
                          readOnly: true,
                        }}
                        fullWidth
                        size="small"
                        autoComplete="false"
                        name="degreeName"
                        label="Your degree"
                        placeholder="Your degree"
                        variant="outlined"
                        value={teacherProfile.degreeName || ""}
                      />
                    </div>
                    <div className="mt-3 col-4 mb-3">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        InputProps={{
                          readOnly: true,
                        }}
                        fullWidth
                        size="small"
                        autoComplete="false"
                        name="specialization"
                        label="Specialization"
                        placeholder="Specialization"
                        variant="outlined"
                        value={teacherProfile.specialization || ""}
                      />
                    </div>
                    <div className="mt-3 col-4 mb-3">
                      <TextField
                        style={{ backgroundColor: "#e9ecef" }}
                        fullWidth
                        size="small"
                        name="graduationDate"
                        value={
                          !!teacherProfile.graduationDate
                            ? moment(teacherProfile.graduationDate).format(
                                "DD/MM/yyyy",
                              )
                            : ""
                        }
                        InputProps={{
                          readOnly: true,
                        }}
                        label="Graduation date"
                        variant="outlined"
                      />
                    </div>
                  </div>

                  <div
                    className="col-12 row no-gutters p-3 mb-3 border border-primary rounded justify-content-center"
                    style={{ backgroundColor: "#ccefff75" }}
                  >
                    <div className="col-12 px-3 mt-2">
                      <fieldset
                        className={`elevated row rounded bg-light form-group border align-items-end p-3`}
                      >
                        <legend
                          className={`col-12 w-auto px-2 text-primary`}
                          style={{
                            fontFamily:
                              '"Roboto","Helvetica","Arial",sans-serif',
                            fontWeight: 400,
                            fontSize: "0.82rem",
                            lineHeight: "1em",
                            letterSpacing: "0.00938em",
                          }}
                        >
                          Assigned Subjects
                        </legend>

                        <div className="col-12">
                          <table className="table table-sm table-bordered">
                            <thead>
                              <tr>
                                <th>Level</th>
                                <th>Class</th>
                                <th>Subject</th>
                              </tr>
                            </thead>
                            <tbody>
                              {teacherSubjects.map((ts) => (
                                <tr key={ts.id}>
                                  <td>
                                    {
                                      ts.schoolSubLevelSubject?.schoolSubLevel
                                        ?.schoolLevel?.name
                                    }
                                  </td>
                                  <td>
                                    {
                                      ts.schoolSubLevelSubject?.schoolSubLevel
                                        ?.name
                                    }
                                  </td>
                                  <td>
                                    {ts.schoolSubLevelSubject?.subject?.name}
                                  </td>
                                </tr>
                              ))}
                              {teacherSubjects.length === 0 && (
                                <tr>
                                  <td colSpan="3" className="text-center">
                                    No subjects assigned
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                        <div className="col-12">
                          <div
                            className="px-4 py-2 "
                            style={{
                              backgroundColor: "#e9ecef",
                              border: "1px solid #cfd3d8",
                            }}
                          >
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={!teacherProfile.isCpdCoordinator}
                                    className="py-0"
                                    checked={teacherProfile.isCpdCoordinator}
                                  />
                                }
                                label="Is CPD Coordinator"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={!teacherProfile.isIEFT}
                                    className="py-0"
                                    checked={teacherProfile.isIEFT}
                                  />
                                }
                                label="Is Inclusive Education Focal Teacher (IEFT)"
                              />

                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={
                                      !teacherProfile.mentorshipSubjectId
                                    }
                                    className="py-0"
                                    checked={
                                      !!teacherProfile.mentorshipSubjectId
                                    }
                                  />
                                }
                                label="Is School Subject Mentor(SSM)"
                              />
                            </FormGroup>

                            {!!teacherProfile.mentorshipSubjectId && (
                              <TextField
                                className="mt-2"
                                InputProps={{ readOnly: true }}
                                fullWidth
                                size="small"
                                autoComplete="false"
                                name="schoolMentorSubject"
                                label="School mentor subjects"
                                placeholder="School mentor subjects"
                                variant="outlined"
                                value={
                                  teacherProfile.mentorshipSubjectName || ""
                                }
                              />
                            )}
                          </div>
                        </div>
                      </fieldset>
                    </div>

                    {!!teacherCertificates.length && (
                      <div className="col-12 px-3 mt-2">
                        <fieldset
                          className={`elevated row rounded bg-light form-group border align-items-end p-3`}
                        >
                          <legend
                            className={`col-12 w-auto px-2 text-primary`}
                            style={{
                              fontFamily:
                                '"Roboto","Helvetica","Arial",sans-serif',
                              fontWeight: 400,
                              fontSize: "0.82rem",
                              lineHeight: "1em",
                              letterSpacing: "0.00938em",
                            }}
                          >
                            Mandatory certificates
                          </legend>

                          <div className="col-12">
                            <table className="table table-sm table-bordered">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Code</th>
                                  <th>Name</th>
                                  <th>Status</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {teacherCertificates.map((cert, index) => (
                                  <tr key={cert.id}>
                                    <td>{index + 1}</td>
                                    <td>{cert.id}</td>
                                    <td>{cert.name}</td>
                                    <td
                                      className={`text-${!!cert.taken ? "success" : "danger"}`}
                                    >
                                      {!!cert.taken ? "Taken" : "Not taken"}
                                    </td>
                                    <td>{/* {cert.status} */}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </fieldset>
                      </div>
                    )}

                    {!!cpdCompletionCertificates.length && (
                      <div className="col-12 px-3 mt-2">
                        <fieldset
                          className={`elevated row rounded bg-light form-group border align-items-end p-3`}
                        >
                          <legend
                            className={`col-12 w-auto px-2 text-primary`}
                            style={{
                              fontFamily:
                                '"Roboto","Helvetica","Arial",sans-serif',
                              fontWeight: 400,
                              fontSize: "0.82rem",
                              lineHeight: "1em",
                              letterSpacing: "0.00938em",
                            }}
                          >
                            CPD completion certificates
                          </legend>

                          <div className="col-12">
                            <table className="table table-sm table-bordered">
                              <thead>
                                <tr>
                                  <th>#</th>
                                  <th>Training</th>
                                  <th>Issued on</th>
                                  <th>Status</th>
                                  <th style={{ width: 140 }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {cpdCompletionCertificates.map((c, index) => (
                                  <tr key={c.id}>
                                    <td>{index + 1}</td>
                                    <td>{c.trainingId}</td>
                                    <td>
                                      {c.issuedOn
                                        ? moment(c.issuedOn).format("DD/MM/YYYY")
                                        : ""}
                                    </td>
                                    <td>{c.status || "ISSUED"}</td>
                                    <td>
                                      <Button
                                        size="small"
                                        variant="outlined"
                                        color="primary"
                                        onClick={() =>
                                          window.open(
                                            `/api/cpd/training-certificates/${c.id}/download`,
                                            "_blank",
                                          )
                                        }
                                      >
                                        Download
                                      </Button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </fieldset>
                      </div>
                    )}

                    <div className="col-12 px-4 mt-2 border elevated rounded bg-light">
                      <fieldset
                        className={`col-12 mt-2 row p-2 no-gutters rounded form-group border bg-light  justify-content-center`}
                      >
                        <legend
                          className={`col-12 w-auto px-2 text-primary`}
                          style={{
                            fontFamily:
                              '"Roboto","Helvetica","Arial",sans-serif',
                            fontWeight: 400,
                            fontSize: "0.82rem",
                            lineHeight: "1em",
                            letterSpacing: "0.00938em",
                          }}
                        >
                          Physical address{" "}
                        </legend>

                        <div className="col-12 col-md-6 mb-2 mt-2 px-2">
                          <Autocomplete
                            size="small"
                            defaultValue={null}
                            value={district}
                            options={districts || []}
                            disabled={loading}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(event, district) => {
                              setDistrict(district || null);

                              setSector(null);
                              setCell(null);
                              setVillage(null);

                              setSectors([]);
                              setCells([]);
                              setVillages([]);
                            }}
                            getOptionLabel={(option) => option.name || ""}
                            renderOption={(props, district) => (
                              <Box component="li" {...props} key={district.id}>
                                {district.name}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                style={{
                                  height: "25px !important",
                                  position: "relative",
                                  borderRadius: "8px",
                                  padding: "1px !important",
                                }}
                                {...params}
                                label="Residence district"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "name",
                                }}
                              />
                            )}
                          />
                        </div>
                        <div className="col-12 col-md-6 mb-2 mt-2 px-2">
                          <Autocomplete
                            size="small"
                            defaultValue={null}
                            value={sector}
                            options={sectors}
                            disabled={loading || !sectors.length}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(event, sector) => {
                              setSector(sector || null);

                              setCell(null);
                              setVillage(null);

                              setCells([]);
                              setVillages([]);
                            }}
                            getOptionLabel={(option) => option.name || ""}
                            renderOption={(props, sector) => (
                              <Box component="li" {...props} key={sector.id}>
                                {sector.name}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                style={{
                                  height: "25px !important",
                                  position: "relative",
                                  borderRadius: "8px",
                                  padding: "1px !important",
                                }}
                                {...params}
                                label="Residence sector"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "name", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />
                        </div>
                        <div className="col-12 col-md-6 mb-2 mt-2 px-2">
                          <Autocomplete
                            size="small"
                            defaultValue={null}
                            value={cell || null}
                            options={cells}
                            disabled={loading || !cells.length}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(event, cell) => {
                              setCell(cell || null);
                              setVillage(null);
                              setVillages([]);
                            }}
                            getOptionLabel={(option) => option.name || ""}
                            renderOption={(props, cell) => (
                              <Box component="li" {...props} key={cell.id}>
                                {cell.name}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                style={{
                                  height: "25px !important",
                                  position: "relative",
                                  borderRadius: "8px",
                                  padding: "1px !important",
                                }}
                                {...params}
                                label="Residence cell"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "name", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />
                        </div>
                        <div className="col-12 col-md-6 mb-2 mt-2 px-2">
                          <Autocomplete
                            size="small"
                            defaultValue={null}
                            value={village || null}
                            options={villages.filter(
                              (v) => !!v.ippisVillageCode,
                            )}
                            disabled={loading || !villages.length}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(event, village) =>
                              setVillage(village || null)
                            }
                            getOptionLabel={(option) => option.name || ""}
                            renderOption={(props, village) => (
                              <Box component="li" {...props} key={village.id}>
                                {village.name}
                              </Box>
                            )}
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                style={{
                                  height: "25px !important",
                                  position: "relative",
                                  borderRadius: "8px",
                                  padding: "1px !important",
                                }}
                                {...params}
                                label="Residence village"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: "name", // disable autocomplete and autofill
                                }}
                              />
                            )}
                          />
                        </div>
                      </fieldset>

                      <fieldset
                        className={`col-12 row rounded no-gutters px-2 bg-light form-group border align-items-end`}
                      >
                        <legend
                          className={`col-12 w-auto px-2 text-primary`}
                          style={{
                            fontFamily:
                              '"Roboto","Helvetica","Arial",sans-serif',
                            fontWeight: 400,
                            fontSize: "0.82rem",
                            lineHeight: "1em",
                            letterSpacing: "0.00938em",
                          }}
                        >
                          Required documents
                        </legend>

                        {profileDocumentTypes?.map((document) => {
                          if (document.id === 5) {
                            return (
                              <div className="col-6 " key={document.id}>
                                <fieldset className={`form-groupborder`}>
                                  <legend
                                    className="w-auto px-2 d-flex align-items-center"
                                    style={{
                                      fontFamily:
                                        '"Roboto","Helvetica","Arial",sans-serif',
                                      fontWeight: 400,
                                      fontSize: "0.82rem",
                                      lineHeight: "1em",
                                      letterSpacing: "0.00938em",
                                      color: `rgba(0, 0, 0, 0.6)`,
                                    }}
                                  >
                                    {document.id}.{" "}
                                    <span className="ml-1">
                                      Do you have any disability?
                                    </span>
                                  </legend>

                                  <div className="form-group1 mb-3 pr-4">
                                    <div className="w-100">
                                      <RadioGroup
                                        row
                                        value={hasDisability}
                                        onChange={(e) => {
                                          const value =
                                            e.target.value === "true";
                                          setHasDisability(value);

                                          if (!value) {
                                            const tmpDocuments = [
                                              ...profileAttachments,
                                            ];
                                            const index =
                                              tmpDocuments.findIndex(
                                                ({ id }) => id === 5,
                                              );
                                            if (index >= 0)
                                              tmpDocuments.splice(index, 1);
                                            setProfileAttachments(tmpDocuments);
                                          }
                                        }}
                                        className="mt-2 ml-4"
                                      >
                                        <FormControlLabel
                                          value={true}
                                          control={<Radio size="small" />}
                                          label="Yes"
                                        />
                                        <FormControlLabel
                                          value={false}
                                          control={<Radio size="small" />}
                                          label="No"
                                        />
                                      </RadioGroup>

                                      {hasDisability && (
                                        <div className="ml-3 w-100">
                                          <legend
                                            className="w-auto d-flex align-items-center mb-2"
                                            style={{
                                              fontFamily:
                                                '"Roboto","Helvetica","Arial",sans-serif',
                                              fontWeight: 400,
                                              fontSize: "0.82rem",
                                              lineHeight: "1em",
                                              letterSpacing: "0.00938em",
                                              color: `rgba(0, 0, 0, 0.6)`,
                                            }}
                                          >
                                            <span>
                                              Upload disability documentation
                                            </span>
                                            <Tooltip
                                              title="This is a document that certifies any special needs or accommodations. Upload documentation of any disability status if applicable, issued by relevant medical authorities or government agencies for support services."
                                              placement="top"
                                              arrow
                                              enterDelay={200}
                                              leaveDelay={200}
                                              componentsProps={{
                                                tooltip: {
                                                  sx: {
                                                    bgcolor:
                                                      "rgba(33, 33, 33, 0.95)",
                                                    color: "white",
                                                    fontSize: "0.875rem",
                                                    fontWeight: 400,
                                                    lineHeight: 1.4,
                                                    padding: "12px 16px",
                                                    borderRadius: "8px",
                                                    maxWidth: "320px",
                                                    boxShadow:
                                                      "0 4px 12px rgba(0, 0, 0, 0.15)",
                                                    border:
                                                      "1px solid rgba(255, 255, 255, 0.1)",
                                                    backdropFilter: "blur(8px)",
                                                    "& .MuiTooltip-arrow": {
                                                      color:
                                                        "rgba(33, 33, 33, 0.95)",
                                                    },
                                                  },
                                                },
                                              }}
                                            >
                                              <Help
                                                fontSize="small"
                                                style={{
                                                  marginLeft: "6px",
                                                  marginBottom: "2px",
                                                  color: "grey",
                                                  cursor: "pointer",
                                                  transition:
                                                    "all 0.2s ease-in-out",
                                                }}
                                              />
                                            </Tooltip>
                                          </legend>
                                          <div className="input-group w-100">
                                            <div className="input-group-prepend">
                                              <span className="input-group-text">
                                                <i className="fas fa-paperclip"></i>
                                              </span>
                                            </div>
                                            {profileAttachments.find(
                                              (doc) =>
                                                doc.id === 5 && !!doc.filename,
                                            ) ? (
                                              <div
                                                className="form-control"
                                                style={{
                                                  backgroundColor:
                                                    "rgb(229, 246, 253)",
                                                  color: "#007bff",
                                                }}
                                              >
                                                <span
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => {
                                                    setShowUploadedDocument(
                                                      true,
                                                    );
                                                    setUploadedDocument({
                                                      name: "Disability Documentation",
                                                      url: profileAttachments.find(
                                                        (doc) =>
                                                          doc.id === 5 &&
                                                          !!doc.filename,
                                                      ).url,
                                                    });
                                                  }}
                                                >
                                                  {
                                                    profileAttachments.find(
                                                      (doc) =>
                                                        doc.id === 5 &&
                                                        !!doc.filename,
                                                    ).filename
                                                  }
                                                </span>
                                                <IconButton
                                                  size="small"
                                                  onClick={() => {
                                                    const tmpDocuments = [
                                                      ...profileAttachments,
                                                    ];
                                                    const index =
                                                      tmpDocuments.findIndex(
                                                        ({ id }) => id === 5,
                                                      );
                                                    if (index >= 0)
                                                      tmpDocuments.splice(
                                                        index,
                                                        1,
                                                      );
                                                    setProfileAttachments(
                                                      tmpDocuments,
                                                    );
                                                  }}
                                                  style={{
                                                    marginTop: "-5px",
                                                    marginRight: "-10px",
                                                  }}
                                                  color="error"
                                                  className="float-right"
                                                  aria-label="remove"
                                                >
                                                  <span className="material-icons">
                                                    close
                                                  </span>
                                                </IconButton>
                                              </div>
                                            ) : (
                                              <input
                                                type="file"
                                                name="file"
                                                style={{
                                                  padding: 0,
                                                  paddingLeft: "3px",
                                                  paddingTop: "3px",
                                                  paddingBottom: "3px",
                                                }}
                                                className="form-control"
                                                accept="application/pdf"
                                                placeholder="Select pdf file"
                                                onChange={(e) =>
                                                  handleUploadedPDFFile(e, {
                                                    id: 5,
                                                    name: "Disability Documentation",
                                                  })
                                                }
                                              />
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </fieldset>
                              </div>
                            );
                          }

                          return (
                            <DocumentItem
                              key={document.id}
                              document={document}
                              profileAttachments={profileAttachments}
                              setProfileAttachments={setProfileAttachments}
                              setShowUploadedDocument={setShowUploadedDocument}
                              setUploadedDocument={setUploadedDocument}
                              handleUploadedPDFFile={handleUploadedPDFFile}
                              getDocumentDescription={getDocumentDescription}
                            />
                          );
                        })}
                      </fieldset>
                      <div className="col-12 pb-3 text-center">
                        <Button
                          className="px-5"
                          variant="contained"
                          color="primary"
                          disableElevation
                          type="button"
                          disabled={loading}
                          onClick={onSave}
                        >
                          Save
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          </div>
        </div>
      </div>

      {showUploadedDocument && uploadedDocument && (
        <PreviewPdfUrl
          isBase64={true}
          showDocument={showUploadedDocument}
          setShowDocument={setShowUploadedDocument}
          document={{
            name: `${uploadedDocument?.name || ""}`,
            url: uploadedDocument?.url || "",
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  user,
  loading,
  onWait,
  placementReportDetails,
  changeList,
  prevPlacementReport,
  signatories,
  roles,
  districts,
  sectors,
  degrees,
  specializations,
  schoolPositions,
  teacherProfile,
  profileDocumentTypes,
  profileDocuments,
}) => {
  return {
    user,
    loading,
    onWait,
    placementReportDetails,
    changeList,
    prevPlacementReport,
    signatories,
    roles,
    districts,
    sectors,
    degrees,
    specializations,
    schoolPositions,
    teacherProfile,
    profileDocumentTypes,
    profileDocuments,
  };
};
export default connect(mapStateToProps, {
  addOrUpdateTeacher,
  getSectors,
  getSchoolPositions,
  getTeacherProfile,
  getDistricts,
  updateUserProfile,
  getProfileDocumentTypes,
  getProfileDocuments,
})(TeacherProfile);

const DocumentItem = (props) => {
  const {
    document,
    profileAttachments,
    setProfileAttachments,
    setShowUploadedDocument,
    setUploadedDocument,
    handleUploadedPDFFile,
    getDocumentDescription,
  } = props;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className="col-6" key={document.id}>
        <fieldset className={`form-groupborder px-2`}>
          <legend
            className="w-auto px-2 d-flex align-items-center"
            style={{
              fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
              fontWeight: 400,
              fontSize: "0.82rem",
              lineHeight: "1em",
              letterSpacing: "0.00938em",
              color: `rgba(0, 0, 0, 0.6)`,
            }}
          >
            {document.id}. <span className="ml-1">{document.name}</span>
            <Tooltip
              title={getDocumentDescription(document.id)}
              placement="top"
              arrow
              enterDelay={200}
              leaveDelay={200}
              componentsProps={{
                tooltip: {
                  sx: {
                    bgcolor: "rgba(33, 33, 33, 0.95)",
                    color: "white",
                    fontSize: "0.875rem",
                    fontWeight: 400,
                    lineHeight: 1.4,
                    padding: "12px 16px",
                    borderRadius: "8px",
                    maxWidth: "320px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(8px)",
                    "& .MuiTooltip-arrow": {
                      color: "rgba(33, 33, 33, 0.95)",
                    },
                  },
                },
              }}
            >
              <Help
                fontSize="small"
                style={{
                  marginLeft: "6px",
                  marginBottom: "2px",
                  color: "grey",
                  cursor: "pointer",
                  transition: "all 0.2s ease-in-out",
                }}
              />
            </Tooltip>
          </legend>
          <div className="form-group1 mb-3">
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <i className="fas fa-paperclip"></i>
                </span>
              </div>
              {profileAttachments.find(
                (doc) => document.id === doc.id && !!doc.filename,
              ) ? (
                <div
                  className="form-control"
                  style={{
                    backgroundColor: "rgb(229, 246, 253)",
                    color: "#007bff",
                  }}
                >
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setShowUploadedDocument(true);
                      setUploadedDocument({
                        name: document.name,
                        url: profileAttachments.find(
                          (doc) => document.id === doc.id && !!doc.filename,
                        ).url,
                      });
                    }}
                  >
                    {
                      profileAttachments.find(
                        (doc) => document.id === doc.id && !!doc.filename,
                      ).filename
                    }
                  </span>

                  <IconButton
                    size="small"
                    onClick={handleOpenMenu}
                    style={{
                      marginTop: "-5px",
                      marginRight: "-10px",
                    }}
                    color="info"
                    className="float-right"
                    aria-label="view"
                  >
                    <MoreHorizIcon />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={(e) => {
                      handleCloseMenu();
                      e.stopPropagation();
                    }}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        overflow: "visible",
                        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                        mt: 1.5,
                        "& .MuiAvatar-root": {
                          width: 32,
                          height: 32,
                          ml: -0.5,
                          mr: 2,
                        },
                        "&:before": {
                          content: '""',
                          display: "block",
                          position: "absolute",
                          top: 0,
                          right: 15,
                          width: 10,
                          height: 10,
                          bgcolor: "background.paper",
                          transform: "translateY(-50%) rotate(45deg)",
                          zIndex: 0,
                        },
                      },
                    }}
                    transformOrigin={{
                      horizontal: "right",
                      vertical: "top",
                    }}
                    anchorOrigin={{
                      horizontal: "right",
                      vertical: "bottom",
                    }}
                  >
                    <span>
                      <MenuItem
                        onClick={(e) => {
                          handleCloseMenu();
                          setUploadedDocument({
                            name: document.name,
                            url: profileAttachments.find(
                              (doc) => document.id === doc.id && !!doc.filename,
                            ).url,
                          });

                          setShowUploadedDocument(true);
                        }}
                        className="text-primary font-weight-bolder"
                      >
                        <span className="material-icons  mr-1">
                          open_in_new
                        </span>
                        Open
                      </MenuItem>
                    </span>

                    <span>
                      <MenuItem
                        onClick={(e) => {
                          handleCloseMenu();

                          const tmpDocuments = [...profileAttachments];

                          const index = tmpDocuments.findIndex(
                            ({ id }) => id === document.id,
                          );

                          if (index >= 0) tmpDocuments.splice(index, 1);

                          setProfileAttachments(tmpDocuments);
                        }}
                        className="text-danger"
                      >
                        <span className="material-icons mr-1">
                          remove_circle_outline
                        </span>
                        Remove
                      </MenuItem>
                    </span>
                  </Menu>
                </div>
              ) : (
                <>
                  <input
                    type="file"
                    name="file"
                    style={{
                      padding: 0,
                      paddingLeft: "3px",
                      paddingTop: "3px",
                      paddingBottom: "3px",
                    }}
                    className="form-control"
                    accept="application/pdf"
                    placeholder="Select pdf file"
                    onChange={(e) => handleUploadedPDFFile(e, document)}
                  />
                </>
              )}
            </div>
          </div>
        </fieldset>
      </div>
    </>
  );
};
